import { useFindById, useFindByName } from '@/context/SelectComponent/Base';
import { useGetCurrencyUnitsAllSuspense } from '@/context/services/currencies/Currencies.service';
import { Currencies } from 'ap-openapi';
import { useCallback } from 'react';

export const useFindCurrencies = () => {
  const items = useGetCurrencyUnitsAllSuspense();
  const findById = useFindById<Currencies, 'id', 'name'>(items, {
    key: 'id',
    return: 'name',
    defaultVal: '',
  });
  const findByName = useFindByName<Currencies, 'name', 'id'>(items, {
    key: 'name',
    return: 'id',
    defaultVal: '',
  });
  const findCurrencyByName = useCallback(
    (value: Parameters<typeof findByName>[0]) => {
      const result = findByName(value?.toUpperCase());
      return result || 'JPY';
    },
    [findByName]
  );
  return {
    findCurrenciesById: findById,
    findCurrenciesByName: findCurrencyByName,
  };
};
